module.exports = __webpack_public_path__ + "img/logo.cfbf9136.png";